var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-white border text-dark number-indicator",attrs:{"data-cy":"number-indicator-body"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }